import { useState, useEffect } from 'react';
import isEqual from 'lodash.isequal';
import usePrevious from '../../../hooks/use-previous';

// types
import { SelectItemProps, UseFilteredListProps } from '../../select/types';

// components
import Highlight from '../highlight';

export default function useFilteredList({
  list,
  searchQuery,
  isOptionsListVisible,
  autocompleteMultiple,
}: UseFilteredListProps): SelectItemProps[] {
  const prevList = usePrevious(list);

  const [filteteredList, setFilteteredList] = useState<SelectItemProps[]>([]);

  useEffect(() => {
    if (!searchQuery?.length) {
      if (
        !isOptionsListVisible ||
        !autocompleteMultiple ||
        (prevList &&
          autocompleteMultiple &&
          !isEqual(
            prevList?.map((item: SelectItemProps) => item.value)?.sort(),
            list?.map((item) => item.value)?.sort(),
          ))
      ) {
        setFilteteredList(list);
      }
    } else {
      const filtered = list
        .map((item: SelectItemProps) => {
          if (
            item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.suffix?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.description?.toLowerCase().includes(searchQuery.toLowerCase())
          ) {
            return {
              ...item,
              highlight: (
                <Highlight searchQuery={searchQuery} text={item.name} />
              ),
            };
          }
          return null;
        })
        .filter((item) => item);

      setFilteteredList(filtered as SelectItemProps[]);
    }
  }, [list, searchQuery]);

  return filteteredList;
}
